class Output extends React.Component {
  constructor() {
    super();
  }

  render () {
    return(
      <div className="output-container">
        <h5 className="output-label">Output</h5>
        <div className="output">
          {this.props.children}
        </div>
      </div>
    );
  }
}
